import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Box,
    Container
} from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    padding: theme.spacing(1.5),
    fontSize: '0.9rem',
    color: 'white',
    verticalAlign: 'top',
    '&.feature-name': {
        width: '19%',
        fontWeight: 'bold'
    },
    '&.feature-value': {
        width: '81%'
    }
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
    },
    '&:nth-of-type(even)': {
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
    },
    '& td': {
        verticalAlign: 'top'
    }
}));

const features = [
    { 
        name: 'Coverage', 
        value: [
            'S&P 500, 400, and 600 companies',
            '10 years of KPIs sourced from 10-K, 10-Q, and 8-Ks',
            'Color commentary from recent earnings calls',
            'Updated as new documents drop'
        ]
    },
    {
        name: 'Data Tools',
        value: [
            'deepKPI \u2014 1M+ KPI time series instantly, 100% auditable',
            'Excel Add-in \u2014 seamlessly integrate with your models'
        ]
    },
    { 
        name: 'Analysis tools', 
        value: [
            'deepAnalysis \u2014 your own equities research assistant',
            'Fast Q&A chat with deepKPI data & SEC filings', 
            'Go Deeper with explanations citing real facts, not the web',
            'Automatically connect earnings calls commentary to KPIs',
            'Comps that actually make sense',
            'Concise company & business segment summaries',
        ]
    }
];

export function LaunchPreviewFeatureTable() {
    return (
        <Box sx={{ maxWidth: '520px' }}>
            
            <Typography 
                variant="h4" 
                sx={{ 
                    mb: 3,
                    fontWeight: 'bold',
                    color: '#ffffff'
                }}
            >
                Make life 10x easier.
            </Typography>
            
            <Typography 
                variant="h6" 
                sx={{ color: 'rgba(255, 255, 255, 0.7)' }}
            >
                Get a one-month <b style={{ color: '#ffffff' }}>free trial</b> with full access to our entire
                financial research & analysis platform.<b style={{ color: '#ffffff' }}> No credit card required.</b>  Then
                as an early adopter, you'll get our best pricing at <b style={{ color: '#ffffff' }}>$25/month</b>.
            </Typography>

            <Box sx={{ mt: 4 }}>
                <TableContainer 
                    component={Paper} 
                    sx={{ 
                        background: 'none',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        borderRadius: 2
                    }}
                >
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell 
                                    colSpan={2} 
                                    align="left"
                                    sx={{
                                        background: 'none',
                                        color: '#ffffff',
                                        paddingTop: 2, paddingBottom: 2, paddingLeft: 1.5,
                                        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                                        fontSize: '1.2rem',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    Features
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {features.map((feature) => (
                                <StyledTableRow key={feature.name}>
                                    <StyledTableCell className="feature-name" align="left">
                                        {feature.name}
                                    </StyledTableCell>
                                    <StyledTableCell className="feature-value">
                                        {feature.value.map((item, index) => (
                                            <div key={index} style={{ marginBottom: '6px', display: 'flex', alignItems: 'flex-start' }}>
                                                <span style={{ marginRight: '8px', color: 'rgb(0, 213, 255)' }}>•</span>
                                                {item}
                                            </div>
                                        ))}
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Box>
    );
}

export default LaunchPreviewFeatureTable; 